/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { KTIcon, toAbsoluteUrl, useIllustrationsPath } from '../../../helpers'
import moment from 'moment'
import { NotificationData } from '../../../layout/components/header/Navbar'

interface HeaderNotificationsMenuProps {
  notificationData: NotificationData[]
  handleNotificationNavigate: (resourceType: string) => void
}

const HeaderNotificationsMenu: FC<HeaderNotificationsMenuProps> = ({
  notificationData,
  handleNotificationNavigate,
}) => {
  moment.updateLocale('en', {
    relativeTime: {
      h: 'an hr',
      hh: '%d hrs',
    },
  })
  const illustrationPath = useIllustrationsPath('1.png')

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div
        className='d-flex flex-column bgi-no-repeat rounded-top'
        style={{ backgroundImage: `url('${toAbsoluteUrl('/media/misc/menu-header-bg.jpg')}')` }}
      >
        <h3 className='text-white fw-bold px-9 mt-10 mb-6'>
          Notifications <span className='fs-8 opacity-75 ps-3'>{notificationData.length} Total</span>
        </h3>
      </div>

      <div className='tab-content'>
        <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
          <div className='scroll-y mh-325px my-5 px-8'>
            {notificationData.length > 0 ? notificationData.map((alert, index) => {
              const { color } = findColor(alert.event_type)
              const displayLabel = formatEventType(alert.event_type)
              return (
                <div key={alert.id} className='py-4'>
                  <div className='d-flex flex-column align-items-end'>
                    <div className='d-flex w-100 flex-column justify-content-start'>
                      <a
                        href='#'
                        className='fs-6 fw-bolder text-gray-800'
                        onClick={() => handleNotificationNavigate(alert.resource_type)}
                      >
                        {alert.title}
                      </a>
                      <div
                        className='fs-7 text-gray-400'
                        title={alert.message}
                        style={{ maxWidth: '320px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                      >
                        {alert.message}
                      </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-between w-100'>
                      <span className={`badge badge-light-${color} fs-9`}>{displayLabel}</span>
                      <span className='badge badge-light fs-9'>{moment(alert.created_at).fromNow()}</span>
                    </div>
                  </div>
                </div>
              )
            }) : (
              <div className='d-flex flex-column px-9'>
                <div className='pt-10 pb-0'>
                  <h3 className='text-dark text-center fw-bolder'>No Notification Found</h3>
                </div>
                <div className='text-center px-4'>
                  <img className='mw-100 mh-200px' alt='transparency' src={illustrationPath} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export { HeaderNotificationsMenu }

const formatEventType = (eventType: string): string => {
  return eventType
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

const findColor = (eventType: string): { color: string } => {
  const lower = eventType.toLowerCase()
  if (lower.includes('reject') || lower.includes('blacklist') || lower.includes('disabl')) {
    return { color: 'danger' }
  }
  if (lower.includes('approv') || lower.includes('whitelist') || lower.includes('enabl')) {
    return { color: 'success' }
  }
  return { color: 'warning' }
}
